import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'DispatchSearchPipe', pure: false })
export class DispatchSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(dispatch => {
        if (dispatch.control_no) {
          return dispatch.control_no.search(searchText) !== -1;
        }
      });
    }
  }
}